import { useState, useCallback } from 'react';
import { api } from '@/lib/api';
import type { FindTimeResult } from '../types';

export function useFindTime() {
  const [result, setResult] = useState<FindTimeResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const findTime = useCallback(
    async (
      participantUsernames: string[],
      rangeStart: string,
      rangeEnd: string,
      durationMinutes: number,
    ) => {
      setLoading(true);
      setError(null);
      try {
        const data = await api.findTime({
          participantUsernames,
          rangeStart,
          rangeEnd,
          durationMinutes,
        });
        setResult(data);
        return data;
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Failed to find available times';
        setError(message);
        setResult(null);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const reset = useCallback(() => {
    setResult(null);
    setError(null);
  }, []);

  return { result, loading, error, findTime, reset };
}
